import Vue from 'vue'
import VModal from 'vue-js-modal'
import { upperFirst, camelCase } from 'lodash'

// Import all Vue components explicitly (replace require.context)
import ButtonComponent from '@application/components/button.vue'
import HeaderComponent from '@application/components/header.vue'
import IntercomTriggerComponent from '@application/components/intercom-trigger.vue'
import LanderStartComponent from '@application/components/lander-start.vue'
import LeadCaptureComponent from '@application/components/lead-capture.vue'
import ModalComponent from '@application/components/modal.vue'
import RotatorComponent from '@application/components/rotator.vue'
import SpinnerComponent from '@application/components/spinner.vue'

Vue.use(VModal)

// Create a component registry to replace require.context functionality
const componentRegistry = {
  'button': ButtonComponent,
  'header': HeaderComponent,
  'intercom-trigger': IntercomTriggerComponent,
  'lander-start': LanderStartComponent,
  'lead-capture': LeadCaptureComponent,
  'modal': ModalComponent,
  'rotator': RotatorComponent,
  'spinner': SpinnerComponent
}

document.addEventListener('DOMContentLoaded', () => {
  // Mount components
  Array
    .from(document.getElementsByClassName('vue-component'))
    .forEach((el) => {

    const componentFileName = el.dataset.component
    const componentProperties = JSON.parse(el.dataset.properties)

    // We generate component name that is in this format: ComponentName
    const componentName = upperFirst(camelCase(componentFileName.replace('/', '-')))

    // Get component from our registry
    const component = componentRegistry[componentFileName]

    if (!component) {
      console.warn(`Component ${componentFileName} not found in registry`)
      return
    }

    // Pass in components using the registry
    const componentsConfig = {
      [componentName]: component,
    }

    new Vue({
      el,

      components: componentsConfig,

      data() {
        return { properties: componentProperties }
      },

      template: `<${componentName} v-bind="properties">${el.innerHTML}</${componentName}>`,
    })
  })
})
